import { createContext, useContext } from "react";

export interface UIContextData {
  darkMode: boolean;
  setDarkMode: (v: boolean) => void;
  animated: Record<string, boolean>;
  getAnimated: (key: string) => boolean;
  setAnimated: (key: string) => void;
  unsetAnimated: (key: string) => void;
}

export const UIContext = createContext<UIContextData | null>(null);

export function useUIContext() {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUIContext must be used within UIProvider");
  }
  return context;
}
